const webEnv = import.meta.env as unknown as { VITE_API_BASE_URL?: string };
const API_BASE = webEnv.VITE_API_BASE_URL ?? '';

export function apiUrl(path: string): string {
  return `${API_BASE}${path}`;
}

export class ApiClientError extends Error {
  constructor(
    public readonly status: number,
    public readonly code: string,
    message: string,
    public readonly details?: unknown,
  ) {
    super(message);
  }
}

export async function api<T>(path: string, init: RequestInit = {}): Promise<T> {
  const headers = new Headers(init.headers);
  if (init.body && !(init.body instanceof FormData) && !headers.has('Content-Type')) {
    headers.set('Content-Type', 'application/json');
  }
  const response = await fetch(apiUrl(path), {
    ...init,
    headers,
    credentials: 'include',
  });
  const body = await response.json().catch(() => null) as {
    error?: { code?: string; message?: string; details?: unknown };
  } | null;
  if (!response.ok) {
    throw new ApiClientError(
      response.status,
      body?.error?.code ?? 'REQUEST_FAILED',
      body?.error?.message ?? 'เกิดข้อผิดพลาด กรุณาลองใหม่',
      body?.error?.details,
    );
  }
  return body as T;
}

export function googleLoginUrl(): string {
  return apiUrl('/api/auth/google');
}

export function delegateLoginUrl(): string {
  return apiUrl('/api/auth/google/delegate');
}

export function appointmentImageUrl(id: string): string {
  return apiUrl(`/api/appointments/${encodeURIComponent(id)}/image`);
}
